import { render, staticRenderFns } from "./DebugVip.vue?vue&type=template&id=16f2b860&scoped=true"
import script from "./DebugVip.vue?vue&type=script&lang=js"
export * from "./DebugVip.vue?vue&type=script&lang=js"
import style0 from "./DebugVip.vue?vue&type=style&index=0&id=16f2b860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f2b860",
  null
  
)

export default component.exports